import { render, staticRenderFns } from "./Antifraude.vue?vue&type=template&id=3eb6b840&scoped=true"
import script from "./Antifraude.vue?vue&type=script&lang=js"
export * from "./Antifraude.vue?vue&type=script&lang=js"
import style0 from "./Antifraude.vue?vue&type=style&index=0&id=3eb6b840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb6b840",
  null
  
)

export default component.exports